<template>
  <div class="ws-flex-gallery">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>